module.exports = __webpack_public_path__ + "static/img/A2E_India_4K5A7046.7889bff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_India_4K5A7046.jpg
// module id = yBCi
// module chunks = 0